import { render, staticRenderFns } from "./CustomerServiceSvg.vue?vue&type=template&id=6b5e0840"
import script from "./CustomerServiceSvg.vue?vue&type=script&lang=js"
export * from "./CustomerServiceSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports